// extracted by mini-css-extract-plugin
module.exports = {"list":"ProjectPreviewItemsList_list__277zT","listItemWrapper":"ProjectPreviewItemsList_listItemWrapper__9DPHI","showMore":"ProjectPreviewItemsList_showMore__3Nq0q"};